export default __webpack_public_path__ + "static/social-municipios-6e6b847d7909895189f73151ef9bf649.png";